class SidecartItems extends HTMLElement {
  static itemEl = 'sidecart-items .previewCartItem';
  static qtyEl = 'cart-update-quantity input';
  static valueEl = '.cart-item-value';
  static totalEl = ['sidecart-items .previewCartTotals-value'];

  constructor() {
    super();
  }
  connectedCallback() {
    this.updateItemPrice();
    this.calculateTotal();
  }

  calculateTotal() {
    const { valueEl, totalEl } = SidecartItems;
    window.RS?.helpers?.sumSpanValues?.(valueEl, ...totalEl);
  }

  updateItemPrice() {
    const { itemEl, qtyEl, valueEl } = SidecartItems;
    const els = document.querySelectorAll(itemEl);
    if ( els?.length ) {
      Array.from(els).forEach(function(el) {
        const qtyElem = el.querySelector(qtyEl);
        const valueElem = el.querySelector(valueEl);
        if ( qtyElem?.value && valueElem?.textContent ) {
          const qty = parseInt(qtyElem.value, 10);
          const value = parseFloat(valueElem.textContent.replace("$", ""));
          valueElem.textContent = `$${(value * qty).toFixed(2)}`;
        }
      });
    }
  }
}

customElements.define('sidecart-items', SidecartItems);